import { useEffect, useState } from 'react'

// Lodash
import _isEmpty from 'lodash/isEmpty'

// Helpers
import {
  getOktaClientId,
  getOktaJwtVerifierInstance,
  getJwtFromSessionToken
} from '../helpers/withEmbedAuthentication.okta'

export const VALIDATION_STATUS = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE'
}

const useOktaVerifier = (
  tenantName
) => {
  const [jwt, setJwtToken] = useState()
  const [sessionToken, setSessionToken] = useState()
  const [isValidSession, setIsValidSession] = useState(false)
  const [validationStatus, setValidationStatus] = useState(VALIDATION_STATUS.PENDING)
  const [error, setError] = useState({})

  const verifyOktaJwt = async (jwtToBeValidated) => {
    await getOktaJwtVerifierInstance(tenantName)
      .verifyAccessToken(jwtToBeValidated, getOktaClientId(tenantName))
      .then(() => {
        setIsValidSession(true)
      })
      .catch((error) => {
        setIsValidSession(false)
        setError({ error })
      }).finally(() => {
        setValidationStatus(VALIDATION_STATUS.COMPLETE)
      })
  }

  useEffect(() => {
    if (!_isEmpty(jwt)) {
      setValidationStatus(VALIDATION_STATUS.IN_PROGRESS)
      verifyOktaJwt(jwt)
    }
  }, [jwt])

  const validateJwtToken = (jwtToBeVerified) => {
    if (!_isEmpty(jwtToBeVerified)) {
      setJwtToken(jwtToBeVerified)
    }
  }

  useEffect(() => {
    if (!_isEmpty(sessionToken)) {
      const jwtTokenDetails = getJwtFromSessionToken(sessionToken, tenantName)
      if ('error' in jwtTokenDetails) {
        setIsValidSession(false)
        return
      }
      const jwt = jwtTokenDetails?.url
        ?.split('#')[1]
        ?.split('&')[0]
        ?.split('=')[1]
      setJwtToken(jwt)
    }
  }, [sessionToken])

  const validateSessionToken = (sessionTokenToBeVerified) => {
    if (!_isEmpty(sessionTokenToBeVerified)) {
      setSessionToken(sessionTokenToBeVerified)
    }
  }

  return {
    isValid: isValidSession,
    validationStatus,
    validateJwtToken,
    validateSessionToken,
    error
  }
}

export default useOktaVerifier
